import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import TourDarkSuccessPromotionLabel from './TourDarkSuccessPromotionLabel'
import { getTourTravelTags } from 'constants/tours'
import { useIntl } from 'react-intl'

interface Props {
  className?: string
  tourId: string
}

function TourTravelTagLabel({ className, tourId }: Props) {
  const intl = useIntl()
  const labels = getTourTravelTags(tourId, intl)

  if (!labels.length) {
    return null
  }

  return <>
    {labels.map((label, index) => <TourDarkSuccessPromotionLabel
      key={`${tourId}-${label.label}`}
      className={index === 0 ? className : undefined}
      icon={label.showIcon ? <LinePlaneDepartureIcon /> : undefined}
      variant="default"
    >
      {label.label}
    </TourDarkSuccessPromotionLabel>)}
  </>
}

export default TourTravelTagLabel
